var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
      _c("span", [_vm._v("Vendor Company")]),
    ]),
    _c("div", { staticClass: "ca-form" }, [
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Company Id" } },
            [
              _c("el-input", {
                attrs: { readonly: "", maxlength: "50" },
                model: {
                  value: _vm.value.vendorCompanyId,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorCompanyId", $$v)
                  },
                  expression: "value.vendorCompanyId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.value.sameAsVendorAddress,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "sameAsVendorAddress", $$v)
                    },
                    expression: "value.sameAsVendorAddress",
                  },
                },
                [_vm._v("Same As Vendor Address")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.value.sameAsVendorAddress,
              expression: "!value.sameAsVendorAddress",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "ca-single-line" },
            [
              _c(
                "el-form-item",
                { staticClass: "w-50", attrs: { label: "Email" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "100",
                      placeholder: "my.name@email.com",
                    },
                    model: {
                      value: _vm.value.companyEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "companyEmail", $$v)
                      },
                      expression: "value.companyEmail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ca-single-line" },
            [
              _c(
                "el-form-item",
                { staticClass: "w-50", attrs: { label: "Phone" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "100", placeholder: "(123) 456-1000" },
                    model: {
                      value: _vm.value.companyPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "companyPhone", $$v)
                      },
                      expression: "value.companyPhone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ca-single-line" },
            [
              _c(
                "el-form-item",
                { staticClass: "w-50", attrs: { label: "Company" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "50", placeholder: "Vendor Company" },
                    model: {
                      value: _vm.value.companyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "companyName", $$v)
                      },
                      expression: "value.companyName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ca-single-line" },
            [
              _c(
                "el-form-item",
                { staticClass: "w-50", attrs: { label: "Address" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "100",
                      placeholder: "1234 Main Street",
                    },
                    model: {
                      value: _vm.value.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "address", $$v)
                      },
                      expression: "value.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ca-single-line" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "City" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "100", placeholder: "City Name" },
                    model: {
                      value: _vm.value.city,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "city", $$v)
                      },
                      expression: "value.city",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-50 ca-inline-items" },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "w-auto", attrs: { label: "State" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "5" },
                        model: {
                          value: _vm.value.state,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "state", $$v)
                          },
                          expression: "value.state",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "w-auto", attrs: { label: "Zip" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "10", placeholder: "5 digit zip" },
                        model: {
                          value: _vm.value.postalCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "postalCode", $$v)
                          },
                          expression: "value.postalCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }